import { Role } from "generated/graphql"
import { useAuth } from "providers/AuthProvider"

export default function useHasRole(allowedRoles: Role[]) {
	const auth = useAuth()
	const userRoles = auth.user?.roles ?? []
	return allowedRoles.some((role) => userRoles.includes(role))
}
